<template>
  <NotificationView
    :icon-src="iconPrivacyTip"
    :card-title="$t(`atualizacaoTermos.${contexto}.title`)"
    btn-text="Aceitar e continuar"
    :btn-disabled="isAccepting"
    @click="aceitar"
  >
    <p v-t="`atualizacaoTermos.${contexto}.body`" />

    <p>
      <a
        v-t="`atualizacaoTermos.${contexto}.moreInfo`"
        :href="moreInfoUrl"
        target="_blank"
        rel="noreferrer"
      />
    </p>
  </NotificationView>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue';

import iconPrivacyTip from '@/assets/images/icons/privacy_tip.svg';
import NotificationView from '@/components/NotificationView.vue';
import { buildLpUrl } from '@/helpers/urlBuilders';

import { authService, sessionService } from '@/services';

type Contexto = 'privacidade' | 'uso' | 'seguranca';

export default defineComponent({
  components: { NotificationView },
  setup() {
    const isAccepting = ref(false);

    const linksTermos: Record<Contexto, string> = {
      privacidade: '/politica-de-privacidade',
      uso: '/termos-de-uso',
      seguranca: '/seguranca',
    };

    const contexto = computed<Contexto>(() => {
      const [policy, ...others] = sessionService.token?.pendingPoliciesToAccept ?? [];

      if (others.length) return 'seguranca';

      switch (policy) {
        case 'politicaPrivacidade':
          return 'privacidade';
        case 'termoUso':
          return 'uso';
        default:
          // erro: política desconhecida ou inexistente no token
          return 'seguranca';
      }
    });

    const moreInfoUrl = computed(() => buildLpUrl(linksTermos[contexto.value]));

    const aceitar = () => {
      if (isAccepting.value) {
        // Esta condição não deve acontecer, pois o botão deve estar desabilitado impedindo a
        // chamada da função. Este early return é apenas uma checagem extra
        return;
      }

      isAccepting.value = true;

      authService.acceptPolicies().finally(() => {
        isAccepting.value = false;
      });
    };

    return {
      iconPrivacyTip,
      contexto,
      moreInfoUrl,
      isAccepting,

      aceitar,
    };
  },
});
</script>

<style lang="scss" scoped>
@use "@/assets/styles/functions.scss" as *;

p {
  font-size: px2rem(14px);
  line-height: 1.5;
  margin-bottom: 1.5em;
}

a {
  color: inherit;
  font-weight: 500;
}
</style>
